<template>
  <div>
    <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table
      v-model="vDataTable.selected"
      :headers="headers"
      :items="vDataTable.data"
      :search="vDataTable.search"
      show-select
      fixed-header
      :expanded.sync="vDataTable.expanded"
      show-expand
      :page.sync="vDataTable.options.page"
      :itemsPerPage.sync="vDataTable.options.itemsPerPage"
      :options.sync="vDataTable.options"
      :height="$vuetify.breakpoint.height - 123 - offsetAppBar"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="node_skey"
      class="fill-height">
      <!-- :item-class="itemRowBackground" -->
      <template v-slot:header.data-table-select="{ on, props }">
        <tr>
          <td>
            <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
          </td>
          <td v-if="vDataTable.selected.length > 0">
            {{vDataTable.selected.length}}
          </td>
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Node</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog.dialogAddEdit" max-width="500px" eager>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize">
                <img src="../../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('navNode.buttonNewNode')}}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-autocomplete
                        :items="nodeTypeList"
                        item-value="code"
                        item-text="description"
                        v-model="vDataTable.editedItem.node_type"
                        :label="$t('navNode.nodeType')">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field :label="$t('navNode.nodeName')" v-model="vDataTable.editedItem.node_name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="vDataTable.editedItem.node_type === 'L'">
                      <v-autocomplete
                        :items="windows"
                        item-value="win_skey"
                        item-text="win_name"
                        v-model="vDataTable.editedItem.win_skey"
                        :label="$t('navNode.nodeWindow')">
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined color="primary" @click="save">{{$t('save')}}</v-btn>
                <v-btn outlined color="primary" @click="close">{{$t('cancel')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
            <img src="../../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>{{$t('navNode.buttonDeleteNode')}}
          </v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" @click.native="expandCollapseNode(true)" style="text-transform: capitalize">Expand</v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" @click.native="expandCollapseNode(false)" style="text-transform: capitalize">Collapse</v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" style="text-transform: capitalize" @click="retrieveNodeDef(appName)">
            <img src="../../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirm(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:item.node_name="{ item }">
        <span :class="itemRowBackground(item)">{{item.node_name}}</span>
      </template>
      <template v-slot:item.data-table-no="{ item, index }">
        {{((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1}}
      </template>
      <template v-slot:no-data>
        <v-alert type="info">
          {{$t('noData')}}
        </v-alert>
      </template>
      <template v-slot:no-results>
        <v-alert type="warning">
          {{stringFormat($t('searchNotFound'),vDataTable.search)}}
        </v-alert>
      </template>
      <template v-slot:footer>
        <tr class="sticky-table-footer" style="position: absolute">
          <td>Selected({{vDataTable.selected.length}})s</td> 
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers, item }"> 
        <td :colspan="headers.length">
          <v-card class="elevation-10">
            <v-card-text>
              <v-tabs color="primary" slider-color="secondary">
                <v-tab style="text-transform: capitalize">{{$t('navNode.tabLanguage')}}</v-tab>
                <v-tab-item>
                  <v-data-table v-model="item.selectedLanguage" 
                                  :headers="subHeadersLanguage"
                                  :items="item.node_language"
                                  :search="item.searchLanguage"
                                  show-select
                                  :footer-props="{
                                    itemsPerPageText: $t('itemsPerPageText'),
                                    itemsPerPageAllText: $t('itemsPerPageAllText'),
                                    showFirstLastPage: true,
                                    showCurrentPage: true,
                                    firstIcon: 'mdi-arrow-collapse-left',
                                    lastIcon: 'mdi-arrow-collapse-right',
                                    prevIcon: 'mdi-minus',
                                    nextIcon: 'mdi-plus',
                                  }"
                                  item-key="uid"
                                  class="elevation-1">
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>Language</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog.dialogLanguage" max-width="500px" eager>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newNodeLanguage(item)">
                              <img src="../../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('navNode.buttonNewNodeLanguage')}}
                            </v-btn>        
                          </template>
                          <v-card>
                            <v-card-title>
                              <span class="headline">{{ formLanguageTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" sm="12" md="12">  
                                    <v-autocomplete
                                      :items="languages"
                                      item-value="language_skey"
                                      item-text="language_comment"
                                      v-model="vDataTable.editedLanguageItem.language_skey"
                                      :label="$t('language')"
                                      :readonly="languageEdit">
                                    </v-autocomplete>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="12">
                                    <v-text-field :label="$t('navNode.nodeName')" v-model="vDataTable.editedLanguageItem.node_name"></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                                <v-btn outlined color="primary" @click="closeLanguage">{{$t('cancel')}}</v-btn>
                                <v-btn outlined color="primary" @click="saveLanguage">{{$t('save')}}</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-divider class="mx-1" inset vertical></v-divider>
                        <v-btn outlined color="primary" @click="checkDeleteselectedLanguage(item)" style="text-transform: capitalize">
                          <img src="../../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>{{$t('navNode.buttonDeleteNodeLanguage')}}
                        </v-btn>
                        <v-divider class="mx-1" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="item.searchLanguage" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-icon color="teal" small class="mr-2" @click="editLanguageItem(item)">edit</v-icon>
                      <v-icon color="pink" small class="mr-2" @click="deleteLanguageConfirm(item)">delete</v-icon>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab style="text-transform: capitalize">{{$t('navNode.tabWindow')}}</v-tab>
                <v-tab-item>
                  <v-data-table :headers="subHeaders"
                                :items="findLogicalWindow(item.node_skey)"
                                  item-key="win_skey"
                                  class="elevation-10">
                  </v-data-table>
                </v-tab-item>
              </v-tabs>
            </v-card-text>
          </v-card>
        </td>
      </template>
    </v-data-table> 
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
export default {
  components: {
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      rules: {
        winName: value => {
          const pattern = /^[a-zA-Z0-9$@$!%*?&#^-_. +]+$/
          return pattern.test(value) || 'Invalid Window Name'
        },
      },
      dialog: {
        dialogProgress: false,
        dialogAddEdit: false,
        dialogLanguage: false,
      },
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: -1,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      progressMessage: '',
      appSkey: -1,
      windows: [],
      languages: [],
      languageEdit: true,
    }
  },

  computed: {
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    formTitle () {
      return this.vDataTable.editedIndex === -1 ? this.$t('navNode.newNode') : this.$t('navNode.newNode')
    },
    formLanguageTitle () {
      return this.vDataTable.editedLanguageIndex === -1 ? this.$t('navNode.newNodeLanguage') : this.$t('navNode.editNodeLanguage')
    },
    nodeTypeList () {
      return [
        { code: 'W', description: this.$t('wayPoint') },
        { code: 'L', description: this.$t('logicalWindow') }
      ]
    },
    headers () {
      return [
        { text: '#', align: 'center', value: 'data-table-no' },
        { text: '', align: 'center', value: 'data-table-select' },
        { text: 'node_skey', align: 'left', value: 'node_skey' },
        { text: this.$t('actions'), value: 'actions', sortable: false },
        { text: 'app_skey', value: 'app_skey', align: 'left' },
        { text: this.$t('navNode.nodeType'), value: 'node_type_desc', align: 'left' },
        { text: this.$t('navNode.nodeName'), value: 'node_name', align: 'left' },
        { text: this.$t('navWindow.windowName'), value: 'win_name', align: 'left' },
        { text: this.$t('createUser'), value: 'create_user_id', align: 'left' },
        { text: this.$t('createDate'), value: 'create_date', align: 'left' },
        { text: this.$t('maintUser'), value: 'maint_user_id', align: 'left' },
        { text: this.$t('maintDate'), value: 'maint_date', align: 'left' },
      ]
    },
    subHeaders () {
      return [
        { text: this.$t('navWindow.windowName'), value: 'win_name' },
        { text: this.$t('createUser'), value: 'create_user_id' },
      ]
    },
    subHeadersLanguage () {
      return [
        { text: '', align: 'center', value: 'data-table-select' },
        { text: this.$t('actions'), value: 'actions', sortable: false },
        { text: this.$t('language'), value: 'language_comment' },
        { text: this.$t('navNode.nodeName'), value: 'node_name', align: 'left' },
      ]
    },
    offsetAppBar () {
      // return this.getShowAppBar ? 0 : this.getAppBarHeight
      return this.getShowAppBar ? this.getAppBarHeight : 0
    },
  },

  watch: {
    'dialog.dialogAddEdit' (val) {
      val || this.close()
    }
  },

  async created () {
    this.retrieveWindow(process.env.VUE_APP_DB_APP_NAME)
    this.retrieveLanguage()
    await this.retrieveNodeDef(this.appName)
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    selectLanguage (language) {
    },
    initialize () {
      this.vDataTable.selected = []
      this.vDataTable.editedIndex = -1
      this.vDataTable.editedItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTable.defaultItem = {
        win_name: '',
        window_comment: ''
      }
    },
    itemRowBackground (item) {
      return item.node_type === 'L' && (item.win_skey === undefined || item.win_skey === null) ? 'style-1' : 'style-2'
    },
    newNodeLanguage (item) {
      this.vDataTable.editedItem = Object.assign({}, item)
      // this.dialogLanguage = true
      this.languageEdit = false
    },
    expandCollapseNode (expand) {
      if (expand) {
        this.vDataTable.expanded = this.vDataTable.data
      } else {
        this.vDataTable.expanded = []
      }
      // for (var item of this.$refs.nodeTable.items) {
      //   this.$set(this.$refs.nodeTable.expanded, item.node_skey, expand)
      // }
    },
    findLogicalWindow (nodeSkey) {
      return this.vDataTable.data.find(function (x) {
        return (x.node_skey === nodeSkey)
      }).logical_window
    },
    findNodeLanguage (nodeSkey) {
      return this.vDataTable.data.find(function (x) {
        return (x.node_skey === nodeSkey)
      }).node_language
    },
    findNodeSelectedLanguage (nodeSkey) {
      return this.vDataTable.data.find(function (x) {
        return (x.node_skey === nodeSkey)
      }).selectedLanguage
    },
    retrieveWindow (appName) {
      this.axios.post(process.env.VUE_APP_API + '/navigation/retrieveWindow' + process.env.VUE_APP_DATABASE_TYPE, {
        app_name: appName
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.appSkey = response.data.data.length > 0 ? response.data.data[0]['app_skey'] : -1
            this.windows = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    retrieveLanguage () {
      this.axios.post(process.env.VUE_APP_API + '/navigation/retrieveLanguage' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.languages = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async retrieveNodeDef (appName) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/navigation/retrieveNodeDef' + process.env.VUE_APP_DATABASE_TYPE, {
        app_name: appName
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.data = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async addNode (appSkey, nodeType, nodeName, winSkey) {
      await this.axios.post(process.env.VUE_APP_API + '/navigation/addNodeDef' + process.env.VUE_APP_DATABASE_TYPE, {
        app_skey: appSkey,
        node_type: nodeType,
        node_name: nodeName,
        win_skey: winSkey
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.editedItem.app_skey = response.data.data.app_skey
            this.vDataTable.editedItem.win_skey = response.data.data.win_skey
            var window = this.windows.find(function (x) {
              return (x.win_skey === response.data.data.win_skey)
            })
            if (window !== undefined) {
              this.vDataTable.editedItem.win_name = window.win_name
            }
            this.vDataTable.editedItem.node_skey = response.data.data.node_skey
            this.vDataTable.editedItem.node_type_desc = this.nodeTypeList.find(function (x) {
              return (x.code === nodeType)
            }).description
            this.vDataTable.data.push(this.vDataTable.editedItem)
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async updateNode (appSkey, nodeSkey, nodeType, nodeName, winSkey) {
      await this.axios.post(process.env.VUE_APP_API + '/navigation/updateNodeDef' + process.env.VUE_APP_DATABASE_TYPE, {
        app_skey: appSkey,
        node_skey: nodeSkey,
        node_type: nodeType,
        node_name: nodeName,
        win_skey: winSkey
      })
        .then(response => {
          if (response.data.isSuccess) {
            if (response.data.data.node_type === 'L') {
              var window = this.windows.find(function (x) {
                return (x.win_skey === response.data.data.win_skey)
              })
              if (window !== undefined) {
                this.vDataTable.editedItem.win_name = window.win_name
              }
            } else {
              this.vDataTable.editedItem.win_name = ''
            }
            this.vDataTable.editedItem.node_type_desc = this.nodeTypeList.find(function (x) {
              return (x.code === nodeType)
            }).description
            Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async addNodeLanguage (appSkey, nodeSkey, languageSkey, nodeName) {
      await this.axios.post(process.env.VUE_APP_API + '/navigation/addNodeLanguage' + process.env.VUE_APP_DATABASE_TYPE, {
        app_skey: appSkey,
        node_skey: nodeSkey,
        language_skey: languageSkey,
        node_name: nodeName
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.editedLanguageItem.app_skey = response.data.data.app_skey
            this.vDataTable.editedLanguageItem.node_skey = response.data.data.node_skey
            this.vDataTable.editedLanguageItem.language_comment = this.languages.find(function (x) {
              return (x.language_skey === languageSkey)
            }).language_comment
            this.findNodeLanguage(nodeSkey).push(this.vDataTable.editedLanguageItem)
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async updateNodeLanguage (appSkey, nodeSkey, languageSkey, nodeName) {
      await this.axios.post(process.env.VUE_APP_API + '/navigation/updateNodeLanguage' + process.env.VUE_APP_DATABASE_TYPE, {
        app_skey: appSkey,
        node_skey: nodeSkey,
        language_skey: languageSkey,
        node_name: nodeName
      })
        .then(response => {
          if (response.data.isSuccess) {
            Object.assign(this.findNodeLanguage(nodeSkey)[this.vDataTable.editedLanguageIndex], this.vDataTable.editedLanguageItem)
            this.$swal({type: 'success', title: response.data.reasonText})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    checkDeleteselected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: this.$t('navNode.confirmDeleteSelected'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('navNode.messageDeleteNotSelected')})
      }
    },
    checkDeleteselectedLanguage (item) {
      if (this.findNodeSelectedLanguage(item.node_skey).length > 0) {
        this.$swal({
          text: this.$t('navNode.confirmNodeLanguageDeleteSelected'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteLanguageSelected(item)
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('navNode.messageDeleteNodeLanguageNotSelected')})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
        this.progressMessage = this.stringFormat(this.$t('navNode.progressMessageDelete'), x.name_name)
        var val = await this.deleteNode(x)

        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))
      for (const x in del) {
        this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      }

      this.dialog.dialogProgress = false
    },
    async deleteLanguageSelected (item) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.utils.asyncForEach(this.findNodeSelectedLanguage(item.node_skey), async function (x) {
        this.progressMessage = this.stringFormat(this.$t('navNode.progressMessageNodeLanguageDelete'), x.node_name)
        var val = await this.deleteLanguage(x)

        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))
      for (const x in del) {
        var selectedLanguage = this.findNodeSelectedLanguage(item.node_skey)
        selectedLanguage.splice(selectedLanguage.indexOf(x), 1)
      }

      this.dialog.dialogProgress = false
    },
    async deleteNode (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var appSkey = item.app_skey
        var nodeSkey = item.node_skey
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/navigation/deleteNodeDef' + process.env.VUE_APP_DATABASE_TYPE, {
          app_skey: appSkey,
          node_skey: nodeSkey
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.vDataTable.data.indexOf(item) >= 0) {
                this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    editItem (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.dialog.dialogAddEdit = true
    },
    editLanguageItem (item) {
      this.languageEdit = true
      this.vDataTable.editedLanguageIndex = this.findNodeLanguage(item.node_skey).indexOf(item)
      this.vDataTable.editedLanguageItem = Object.assign({}, item)
      this.dialog.dialogLanguage = true
    },
    async deleteItemConfirm (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat(this.$t('navNode.confirmDelete'), item.node_name),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteNode(item)
          if (val !== undefined) {
            if (this.vDataTable.selected.indexOf(this.vDataTable.editedItem) >= 0) {
              this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(this.vDataTable.editedItem), 1)
            }
          }
          this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
          this.vDataTable.editedIndex = -1
        }
      })
    },
    async deleteLanguage (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var appSkey = item.app_skey
        var nodeSkey = item.node_skey
        var languageSkey = item.language_skey
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/navigation/deleteNodeLanguage' + process.env.VUE_APP_DATABASE_TYPE, {
          app_skey: appSkey,
          node_skey: nodeSkey,
          language_skey: languageSkey
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.findNodeLanguage(item.node_skey).indexOf(item) >= 0) {
                this.findNodeLanguage(item.node_skey).splice(this.findNodeLanguage(item.node_skey).indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async deleteLanguageConfirm (item) {
      this.vDataTable.editedLanguageIndex = this.findNodeLanguage(item.node_skey).indexOf(item)
      this.vDataTable.editedLanguageItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat('Are you sure delete language {} node {}?', item.language_comment, item.node_name),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteLanguage(item)
          if (val !== undefined) {
            var selectedLanguage = this.findNodeSelectedLanguage(item.node_skey)
            if (selectedLanguage.indexOf(item) >= 0) {
              selectedLanguage.splice(selectedLanguage.indexOf(item), 1)
            }
          }
          this.vDataTable.editedLanguageItem = Object.assign({}, this.vDataTable.defaultItem)
          this.vDataTable.editedLanguageIndex = -1
        }
      })
    },
    close () {
      this.dialog.dialogAddEdit = false
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
    },
    async save () {
      if (this.vDataTable.editedIndex > -1) {
        await this.updateNode(this.appSkey, this.vDataTable.editedItem.node_skey, this.vDataTable.editedItem.node_type, this.vDataTable.editedItem.node_name, this.vDataTable.editedItem.win_skey)
      } else {
        await this.addNode(this.appSkey, this.vDataTable.editedItem.node_type, this.vDataTable.editedItem.node_name, this.vDataTable.editedItem.win_skey)
      }
      this.close()
    },
    closeLanguage () {
      this.dialog.dialogLanguage = false
      this.$nextTick(() => {
        this.vDataTable.editedLanguageItem = Object.assign({}, this.vDataTable.defaultLanguageItem)
        this.vDataTable.editedLanguageIndex = -1
      })
    },
    async saveLanguage () {
      if (this.vDataTable.editedLanguageIndex > -1) {
        await this.updateNodeLanguage(this.appSkey, this.vDataTable.editedLanguageItem.node_skey, this.vDataTable.editedLanguageItem.language_skey, this.vDataTable.editedLanguageItem.node_name)
      } else {
        await this.addNodeLanguage(this.appSkey, this.vDataTable.editedItem.node_skey, this.vDataTable.editedLanguageItem.language_skey, this.vDataTable.editedLanguageItem.node_name)
      }
      this.closeLanguage()
    }
  },
}
</script>
<style scoped>
.style-1 {
  color: rgb(215, 44, 44);
}
.style-2 {
  color: rgb(114,114,67);
}
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
</style>